import { render, staticRenderFns } from "./ParcelDetail.vue?vue&type=template&id=1670c818&scoped=true&"
import script from "./ParcelDetail.vue?vue&type=script&lang=js&"
export * from "./ParcelDetail.vue?vue&type=script&lang=js&"
import style0 from "./ParcelDetail.vue?vue&type=style&index=0&id=1670c818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1670c818",
  null
  
)

export default component.exports